import { gql } from '@apollo/client';

export const FETCH_PROFILE_DETAILS_QUERY = gql`
  query fetchProfileDetails {
    fetchProfileDetails {
      basicProfileDetails {
        firstName
        lastName
        preferredName
        gender
        dob
        bloodGroup
        avatarUrl
        userId
      }
      contactProfileDetails {
        phoneNumberList {
          phoneNumber
        }
        emailIdList {
          emailAddress
        }
        addressList {
          addressLine1
          addressLine2
          zipCode
          state
          city
        }
      }
    }
  }
`;

export const FETCH_PATIENT_ID = gql`
  query getPatientIdFromkeycloakId {
    getPatientIdFromkeycloakId {
      patientId
    }
  }
`;
